/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DocumentUploadPreviewTranslationsFaceCloseupPoint2 } from './DocumentUploadPreviewTranslationsFaceCloseupPoint2';
import type { DocumentUploadPreviewTranslationsFaceCloseupPoint3 } from './DocumentUploadPreviewTranslationsFaceCloseupPoint3';
import type { DocumentUploadPreviewTranslationsFaceCloseupPoint1 } from './DocumentUploadPreviewTranslationsFaceCloseupPoint1';

export interface DocumentUploadPreviewTranslationsFaceCloseup {
    point_1: DocumentUploadPreviewTranslationsFaceCloseupPoint1;
    point_2: DocumentUploadPreviewTranslationsFaceCloseupPoint2;
    point_3: DocumentUploadPreviewTranslationsFaceCloseupPoint3;
}
